import * as React from 'react'
import { ReactElement } from 'react'
import { Field, Input, Textarea } from '@fluentui/react-components'
import BaseCombobox from '../../Combobox/BaseCombobox'
import { InjuryPanelProps } from './FormContainer'
import LocalDatePicker from '../../DatePicker/LocalDatePicker'
import AccidentTypeCombobox from '../../Combobox/AccidentTypeCombobox'
import InjuryTypeCombobox from '../../Combobox/InjuryTypeCombobox'

type Props = InjuryPanelProps & {}

const DropdownOptions = ['Ja', 'Nee', 'Onbekend']

export default function BaseDataPanel(props: Props): ReactElement {
    return (
        <div className={props.styles.formRow}>
            <Field label="Datum ongeval" orientation={props.orientation}>
                <LocalDatePicker />
            </Field>
            <Field label="Soort ongeval" orientation={props.orientation}>
                <AccidentTypeCombobox onOptionSelect={() => {}} />
            </Field>

            <Field label="Toedracht" orientation={props.orientation}>
                <Textarea />
            </Field>
            <Field label="Locatie" orientation={props.orientation}>
                <Input />
            </Field>

            <Field label="Soort letsel" orientation={props.orientation}>
                <InjuryTypeCombobox onOptionSelect={() => {}} />
            </Field>
            <Field label="Omschrijving letsel" orientation={props.orientation}>
                <Textarea />
            </Field>
            <Field label="Getuigen aanwezig" orientation={props.orientation}>
                <BaseCombobox<string>
                    entities={DropdownOptions}
                    getEntityLabel={entity => entity}
                    getEntityValue={entity => entity}
                    onOptionSelect={() => {}}
                />
            </Field>
            <Field label="Omschrijving letsel" orientation={props.orientation}>
                <Textarea />
            </Field>
        </div>
    )
}
